// extracted by mini-css-extract-plugin
export default {"gallery":"c-n_fv","gallery__header":"c-n_fw","gallery__thumbs":"c-n_fx"};